import React from "react";
import { TbMenuDeep } from "react-icons/tb";
import { FiEdit } from "react-icons/fi";
import "./Navbar.css";
import { useNavigate } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import SidebarMain from "../Sidebar/SidebarMain";
import { useClientId } from "../../context/ClientsProvider";
import { IconButton } from "../../design-system/components";

const MobileNavbar = () => {
  const navigate = useNavigate();
  const clientId = useClientId();
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  return (
    <>
      <nav className="mobile-nav">
        <div className="copilot-logo--wrapper">
          <img src="/logo.svg" alt="" />
        </div>
        <div className="mobile-nav-actions--wrapper">
          <IconButton
            label="Open conversation menu"
            size="md"
            onClick={toggleDrawer(true)}
          >
            <TbMenuDeep style={{ transform: "rotate(180deg)" }} />
          </IconButton>
          <IconButton
            label="New conversation"
            size="md"
            onClick={() => {
              navigate(clientId ? `/${encodeURIComponent(clientId)}` : "/");
            }}
          >
            <FiEdit />
          </IconButton>
        </div>
      </nav>

      <Drawer open={open} onClose={toggleDrawer(false)}>
        <SidebarMain isCollapsed={false} toggleDrawer={toggleDrawer} />
      </Drawer>
    </>
  );
};

export default MobileNavbar;
